import { VideoLayerData } from "../layers/videoLayerData.model.tsx";
import { BaseSerializer } from "./baseSerializer.ts";

export class VideoSerializer extends BaseSerializer {
  public deserialize(data: any): any {
    this._normalizeSource(data);
    const gp = new VideoLayerData(data);

    return gp;
  }
}
